import { useStepsContext } from '../context/StepsContext'
import { useSelector } from 'react-redux'
import Button from './Button'

interface Props {
  storeForm: string
}

const AddressButton = ({ storeForm }: Props) => {
  const { idStep, setIdStep }: any = useStepsContext()
  const { addressFloor, addressFlat, ...others } = useSelector((state: any) => state[storeForm])
  const validity = Object.values(others).some((value: any) => !value)
  const continueManualValidation = () => {
    setIdStep(idStep + 1)
  }
  return (
    <Button
      id="continue-step-id-validation"
      className="submit-button btn-margin-down"
      label="Continuar"
      validity={validity}
      handleSubmit={continueManualValidation}
    />
  )
}

export default AddressButton
